/**
 * Instructor cockpit live chat island.
 *
 * The GetStream `stream-chat-react` SDK is heavy, so it lives in a standalone UMD
 * bundle (`js/live_chat.js`, global `LiveChatCockpit`) that is loaded on demand the
 * first time the chat tab is opened, rather than shipped in the main app bundle.
 *
 * The container is rendered with `phx-update="ignore"` so LiveView's DOM diffing
 * never touches the React-managed subtree. `destroyed()` unmounts React on tab
 * navigation, which disconnects the GetStream websocket (no zombie connections).
 */

let liveChatBundlePromise = null;

// Digested URLs come from the mount element's dataset so a deploy busts the cache.
const loadLiveChatBundle = (bundleUrl, stylesUrl) => {
  if (window.LiveChatCockpit) return Promise.resolve();
  if (liveChatBundlePromise) return liveChatBundlePromise;

  liveChatBundlePromise = new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${stylesUrl}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = stylesUrl;
      document.head.appendChild(link);
    }

    const script = document.createElement("script");
    script.src = bundleUrl;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Failed to load the live chat bundle."));
    document.head.appendChild(script);
  });

  return liveChatBundlePromise;
};

const hook = {
  mounted() {
    const props = {
      appKey: this.el.dataset.appKey,
      userId: this.el.dataset.userId,
      channelCids: JSON.parse(this.el.dataset.channelCids),
      tokenUrl: this.el.dataset.tokenUrl,
      locale: this.el.dataset.locale,
      labels: JSON.parse(this.el.dataset.labels),
      activeChannelId: this.el.dataset.activeChannelId,
    };

    loadLiveChatBundle(this.el.dataset.bundleUrl, this.el.dataset.stylesUrl).then(() => {
      // The tab may have been left before the bundle finished loading.
      if (!this.el.isConnected) return;
      this.reactRoot = window.LiveChatCockpit.liveChatCockpitRender(this.el.id, props);
    });
  },
  destroyed() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }
  },
};

export default hook;
